import { FloatingOverlay } from "@floating-ui/react"
import classNames from "classnames"
import { forwardRef } from "react"
import { OverlayProps } from "./types"

export const Overlay = forwardRef<HTMLDivElement, OverlayProps>(
  ({ children = null, className = "", lockScroll = false, variation = "dark", ...rest }, ref) => {
    return (
      <FloatingOverlay
        ref={ref}
        lockScroll={lockScroll}
        className={classNames(
          { "bg-[rgb(0,0,0)]/60": variation === "dark", "bg-white/60": variation === "light" },
          className,
        )}
        {...rest}
      >
        {children}
      </FloatingOverlay>
    )
  },
)
